import { Outlet } from 'react-router';

import { useVoicesList } from '@/entities/voice';

import { FormStatusProvider } from '../lib/FormStatusProvider';
import { VoiceList } from './VoiceList';

export function VoicesPage() {
  const { data: voices = [], isLoading } = useVoicesList();

  return (
    <FormStatusProvider>
      <div className="w-full h-full p-6 overflow-hidden flex flex-col">
        <div className="mb-4 flex-shrink-0">
          <h1 className="text-heading font-bold text-gray-900 mb-1">Voices</h1>
          <p className="text-detail text-gray-600">
            Create and manage voices for your AI agents
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-4 flex-1 min-h-0">
          {/* Left Panel */}
          <VoiceList voiceItems={voices} isLoading={isLoading} />

          {/* Right Panel */}
          <div className="flex-1 overflow-y-auto">
            <Outlet />
          </div>
        </div>
      </div>
    </FormStatusProvider>
  );
}